export const dashboardComputed = {
    showFrequentTilesSection() {
        return this.isSearchInputActive === true && !this.frequentTilesError;
    },

    frequentTilesHasItems() {
        return Array.isArray(this.frequentTilesCurrentBook) && this.frequentTilesCurrentBook.length > 0;
    },

    frequentTilesDisplayList() {
        return Array.isArray(this.frequentTilesCurrentBook) ? this.frequentTilesCurrentBook.slice(0, 5) : [];
    },

    dynamicVH2() {
        return {
            height: `${this.vh2Value}vh`,
        };
    },

    dynamicVH1() {
        return {
            height: `${this.vh1Value}vh`,
        };
    },

    dynamicVH3() {
        return {
            height: `${this.vh3Value}vh`,
        };
    },

    showTile() {
        if (this.$store.getters.newload === true) {
            document.onclick = () => {
                setTimeout(() => {
                    this.select_books();
                }, 10);
            };
        }

        if (this.search_tile && this.search_tile.trim() !== "") {
            if (this.$store.getters.active_pages) {
                let testArray = [];
                testArray.push(
                this.$store.getters.active_pages.map((page) => {
                    return page.tiles.filter((item) => {
                        if (this.$store.getters.web_only === true) {
                            if (
                                item.book_code === this.$store.getters.selected_book &&
                                item.is_web_available === "yes"
                            ) {
                            return (
                                item.title
                                .toLowerCase()
                                .includes(this.search_tile.toLowerCase()) ||
                                (item.keyword &&
                                item.keyword
                                .toLowerCase()
                                .includes(this.search_tile.toLowerCase()))
                            );
                        }
                    } else {
                        if (item.book_code === this.$store.getters.selected_book) {
                            return (
                                item.title
                                    .toLowerCase()
                                    .includes(this.search_tile.toLowerCase()) ||
                                (item.keyword &&
                                    item.keyword
                                    .toLowerCase()
                                    .includes(this.search_tile.toLowerCase()))
                            );
                        }
                    }
                });
                })
            );
            let merged = [].concat.apply([], testArray[0]);
            return [merged];
        } else {
            return "";
        }
    }

      // 3. Default (no search at all)
    else if (this.$store.getters.active_pages != null) {
        if (this.$store.getters.web_only === true) {
            return this.$store.getters.active_pages
            .filter((page) => page.title === this.$store.getters.selected_page)
            .map((page) => {
                return page.tiles.filter((item) => {
                    return item.is_web_available === "yes";
                });
            });
        } else {
            return this.$store.getters.active_pages
            .filter((page) => page.title === this.$store.getters.selected_page)
            .map((page) => page.tiles);
        }
    } else {
        return "";
    }
    },

    searchTileCount() {
        return this.showTile[0].length;
    },
};